<template>
    <div id="popupRoot"></div>
    <DxPopup v-model:visible="popup.visible" :title="popup.title" width="auto" height="auto" :content-template="popup.template"
             target="#popupRoot">
        <template #addNewRecord>
            <div class="pudBox">
                <div class="pudCell">
                    <div class="puLabel">Topic Link Type:</div>
                    <div class="puValue">
                        <DxSelectBox :data-source="topicLinkTypeList"
                                     :show-clear-button="false"
                                     display-expr="TltName"
                                     value-expr="TltId"
                                     v-model:value="popup.TltId">
                        </DxSelectBox>
                    </div>
                </div>
                <div class="pudCell">
                    <div class="puLabel">Trigger Status:</div>
                    <div class="puValue">
                        <DxSelectBox :data-source="triggerStatusList"
                                     :show-clear-button="false"
                                     display-expr="StatusName"
                                     value-expr="StatusID"
                                     v-model:value="popup.StatusId">
                        </DxSelectBox>
                    </div>
                </div>
                <div class="pudButtons">
                    <div class="puLeftButtons">
                        <DxButton text="Cancel" @click="hidePopup" />
                    </div>
                    <div class="puRightButtons">
                        <DxButton text="Add" type="success" @click="addTopicLinkTypeStatus" :disabled="!(popup.StatusId > 0 && popup.TltId > 0)" />
                    </div>
                </div>
            </div>
        </template>
    </DxPopup>
    <div v-bind:class="readAccessClasses">
        <div class="na-list">
            <DxDataGrid v-model:data-source="topicLinkTypeStatusList"
                        key-expr="TlsId"
                        :activeStateEnabled="true"
                        :allowColumnReordering="true"
                        :allowColumnResizing="true"
                        :rowAlternationEnabled="true"
                        @exporting="onExporting"
                        :show-borders="true">
                <DxEditing mode="batch"
                           :allow-updating="false"
                           :allow-adding="false"
                           :allow-deleting="false"
                           startEditAction="click" />
                <DxColumnChooser :enabled="true" />
                <DxColumnFixing :enabled="true" />
                <DxFilterPanel :visible="true" />
                <DxFilterRow :visible="true" />
                <DxHeaderFilter :visible="true" />
                <DxSearchPanel :visible="true" placeholder="Search..." />
                <DxLoadPanel :enabled="true" />
                <DxPaging :page-size="15" />
                <DxPager :visible="true"
                         :allowed-page-sizes="100"
                         :display-mode="full"
                         :show-page-size-selector="true"
                         :show-info="true"
                         :show-navigation-buttons="true" />
                <DxSorting mode="multiple" />
                <DxGroupPanel :visible="true" />
                <DxStateStoring :enabled="false"
                                type="localStorage"
                                storage-key="topicLinkTypeList" />
                <DxExport :enabled="true" :allow-export-selected-data="true" />


                <DxColumn caption='ActionColumn' data-type="string" css-class="actionColumn" header-cell-template="headerTemplate"
                          :allow-editing="false" :allow-filtering="false" :allow-resizing="false" :width="100"
                          :allow-column-reorder="false" :fixed="true" alignment="center" :show-in-column-chooser="false"
                          :allow-search="false" cell-template="actionTemplate" />
                <DxColumn caption='ID' data-type="number" data-field='TlsId' :allow-editing="false" :width="100" />
                <DxColumn :caption='col.TlsName' data-type='string' data-field='TlsName' :allow-editing="false" />
                <DxColumn :caption='col.GrpName' data-type='string' data-field='GrpName' :allow-editing="false" />
                <DxColumn :caption='col.TlsShowInProfile' data-type='boolean' data-field='TlsShowInProfile' :allow-editing="false" />
                <DxColumn :caption='col.TlsCreateButtonText' data-type='string' data-field='TlsCreateButtonText' :allow-editing="false" />
                <DxColumn :caption='col.TriggerStatusWorkflowName' data-type='string' data-field='TriggerStatusWorkflowName' :allow-editing="false" />
                <DxColumn :caption='col.TriggerStatusName' data-type='string' data-field='TriggerStatusName' :allow-editing="false" />
                <DxColumn :caption='col.InitialStatusName' data-type='string' data-field='InitialStatusName' :allow-editing="false" />
                <DxColumn :caption='col.SelectionTopicTypeName' data-type='string' data-field='SelectionTopicTypeName' :allow-editing="false" />
                <DxColumn :caption='col.OwnerTopicTypeName' data-type='string' data-field='OwnerTopicTypeName' :allow-editing="false" />
                <DxColumn :caption='col.AssigneeTopicTypeName' data-type='string' data-field='AssigneeTopicTypeName' :allow-editing="false" />

                <DxColumn :caption='col.TltCreatedBy' data-type='string' data-field='TltCreatedBy' :allow-editing="false" :visible="false" :width="100" />
                <DxColumn :caption='col.TltCreatedOn' data-type='date' data-field='TltCreatedOn' :allow-editing="false" :visible="false" :width="100" />
                <DxColumn :caption='col.TltChangedBy' data-type='string' data-field='TltChangedBy' :allow-editing="false" :visible="false" :width="100" />
                <DxColumn :caption='col.TltChangedOn' data-type='date' data-field='TltChangedOn' :allow-editing="false" :visible="false" :width="100" />

                <template #actionTemplate="{data }">
                    <div class="edtActionButtons">
                        <DxButton class="edtButton" icon="ca-read far fas fa-pen" @click="viewRecord(data)"></DxButton>
                    </div>
                </template>
                <template #headerTemplate>
                    <div class="edtActionButtons">
                        <DxButton class="edtButton" icon="fas fa-plus" @click="addRecord" :disabled="!allowCreate"></DxButton>
                    </div>
                </template>
            </DxDataGrid>
        </div>
    </div>
</template>
<script>
    import {
        DxDataGrid,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxSorting,
        DxPaging,
        DxPager,
        DxColumn,
        DxFilterPanel,
        DxStateStoring,
        DxGroupPanel,
        DxExport,
        DxEditing
    } from 'devextreme-vue/data-grid'
    import DxPopup from "devextreme-vue/popup"
    import DxButton from 'devextreme-vue/button'
    import DxSelectBox from 'devextreme-vue/select-box'

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    export default {
        name: 'TopicLinkTypeStatusList',
        components: {
            DxButton,
            DxDataGrid,
            DxColumnChooser,
            DxColumnFixing,
            DxFilterRow,
            DxHeaderFilter,
            DxSearchPanel,
            DxLoadPanel,
            DxSorting,
            DxPaging,
            DxPager,
            DxFilterPanel,
            DxStateStoring,
            DxColumn,
            DxGroupPanel,
            DxExport,
            DxEditing,
            DxPopup,
            DxSelectBox
        },

        data() {
            return {
                popup: {
                    title: '',
                    visible: false,
                    StatusId: 0,
                    TltId: 0
                },
                col: {
                    TlsName: this.$LanguageProvider.GetResource("TlsName", "Caption", "Name"),
                    TriggerStatusWorkflowName: this.$LanguageProvider.GetResource("TriggerStatusWorkflowName", "Caption", "Workflow"),
                    TriggerStatusName: this.$LanguageProvider.GetResource("TriggerStatusName", "Caption", "Trigger Status"),
                    InitialStatusName: this.$LanguageProvider.GetResource("InitialStatusName", "Caption", "Initial Status"),
                    OwnerTopicTypeName: this.$LanguageProvider.GetResource("OwnerTopicTypeName", "Caption", "Owner Topic Type"),
                    AssigneeTopicTypeName: this.$LanguageProvider.GetResource("AssigneeTopicTypeName", "Caption", "Assignee Topic Type"),
                    SelectionTopicTypeName: this.$LanguageProvider.GetResource("SelectionTopicTypeName", "Caption", "Selection Topic Type"),
                    GrpName: this.$LanguageProvider.GetResource("GrpName", "Caption", "Group"),
                    TlsShowInProfile: this.$LanguageProvider.GetResource("TlsShowInProfile", "Caption", "Show Action Buttons"),
                    TlsCreateButtonText: this.$LanguageProvider.GetResource("TlsCreateButtonText", "Caption", "Action Button Text"),


                    TlsCreatedBy: this.$LanguageProvider.GetResource("TlsCreatedBy", "Caption", "Created By"),
                    TlsCreatedOn: this.$LanguageProvider.GetResource("TlsCreatedOn", "Caption", "Created On"),
                    TlsChangedBy: this.$LanguageProvider.GetResource("TlsChangedBy", "Caption", "Changed By"),
                    TlsChangedOn: this.$LanguageProvider.GetResource("TlsChangedOn", "Caption", "Changed On"),
                }

            }
        },
        computed: {
            topicLinkTypeStatusList() {
                return this.$store.state.topicLinkTypeStatusStore.topicLinkTypeStatusList;
            },
            topicLinkTypeList() {
                return this.$store.state.topicLinkTypeStore.topicLinkTypeList;
            },
            accessList() {
                return this.$store.state.accessStore.accessList
            },
            allowEdit() {
                return this.accessList._300772;
            },
            allowCreate() {
                return this.accessList._300774;
            },
            statusList() {
                return this.$store.state.statusStore.statusListSimple;
            },
            triggerStatusList() {
                if (this.popup.TltId > 0) {
                    var tlt = this.topicLinkTypeList.find(m => m.TltId == this.popup.TltId);
                    if (tlt) {
                        return this.$store.state.statusStore.statusListSimple.filter(m => m.WorId == tlt.WorId1 || m.WorId == tlt.WorId2);
                    }
                }
                return [];
            },
        },
        watch: {
        },
        mounted: function () {
            this.$store.dispatch("getTopicLinkTypeStatusList", {})
            this.$store.dispatch("getTopicLinkTypeList", {})
            this.$store.dispatch("getStatusListSimple", { worId: 0 })
            this.$store.dispatch("getAccessList", { tokenList: ["300771", "300772", "300774", "30078"] })
        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            viewRecord: function (record) {
                var url = window.location.pathname.replace('TopicLinkTypeStatusListVx', 'TopicLinkTypeStatusDetailVx') + "?tlsId=" + record.key;
                window.post(url, {});
            },
            hidePopup: function () {
                this.popup.visible = false;
            },
            addRecord: function () {
                this.popup.template = "addNewRecord";
                this.popup.title = "Add New Workflow Entry Point";
                this.popup.visible = true;
            }
        }
    }
</script>
<style scoped> 

    .edtActionButtons {
        display: block;
    }

    .pudCell {
        display: grid;
        align-items: center;
        gap: 20px;
        grid-template-columns: auto auto;
    }

    .pudButtons {
        display: flex;
        justify-content: space-evenly;
        padding: 20px 0 0 0;
    }
</style>